<template>
  <v-navigation-drawer
    :value="value"
    :width="$vuetify.breakpoint.xsOnly ? '100%' : '400'"
    app
    right
    temporary
    overlay-opacity="0.3"
    class="NotificationsDrawer"
    @input="$emit('input', $event)"
  >
    <v-toolbar flat>
      <v-toolbar-title class="font-weight-medium">Notifications</v-toolbar-title>
      <v-spacer />
      <v-btn
        icon
        @click="$emit('input', false)"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'NotificationsDrawer',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
